import { render, staticRenderFns } from "./LibSearchFormHost.vue?vue&type=template&id=2a0f68dc&"
import script from "./LibSearchFormHost.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LibSearchFormHost.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports